<template>
  <div>
    <basic-container>
      <div class="page-container">
        <div class="query-form-wrap">
          <el-form :inline="true" :model="form" :size="formSize">
            <el-form-item>
              <date-range-destructor
                :start.sync="form.createDateBegin"
                :end.sync="form.createDateEnd"
                start-placeholder="申请开始时间"
                end-placeholder="申请结束时间"
                value-format="yyyy-MM-dd"
                type="daterange"                
                format = "yyyy-MM-dd">
              </date-range-destructor>
            </el-form-item>
            <el-form-item>
              <el-select clearable v-model="form.incomeStatus" placeholder="提现状态">
                <el-option
                  v-for="item in withdrawStatusOptions"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input clearable v-model="form.keyword" placeholder="提现订单号/合伙人账号"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button v-auth="'ACTIVITY_PARTNER_SEARCH'" :loading="listLoading" icon="el-icon-search" type="primary" @click="handleSearch">搜索</el-button>
              <el-button v-auth="'GIFT_MANAGE_EXPORT'" type="warning" plain icon="el-icon-download" @click="handleExport">导出</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-wrap">
          <el-table
            :data="withdrawList"
            :height="autoTableHeight"
            v-loading="listLoading"
            ref="eltable"
            border
            style="width: 100%">
            <el-table-column
              type="index"
              fixed
              label="序号"
              width="50">
            </el-table-column>
            <el-table-column
              prop="paymentNo"
              label="提现订单号"
              min-width="300">
            </el-table-column>
            <el-table-column
              prop="userAccount"
              align="center"
              header-align="center"
              label="合伙人账号"
              width="250">
            </el-table-column>
            <el-table-column
              prop="withdrawalAmount"
              align="right"
              header-align="right"
              label="提现金额（元）"
              sortable
              width="180">
            </el-table-column>
            <el-table-column
              prop="withdrawalType"
              align="center"
              :formatter="formatType"
              header-align="center"
              label="提现方式"
              width="180">
            </el-table-column>
            <el-table-column
              prop="status"
              align="center"
              width="120"
              :formatter="formatStatus"
              header-align="center"
              label="提现状态">
            </el-table-column>
            <el-table-column
              prop="createTime"
              align="center"
              header-align="center"
              label="申请时间"
              sortable
              width="180">
            </el-table-column>
          </el-table>
        </div>
        <div class="table-pagination">
          <TablePagination
            :page-size.sync="pageConfig.size"
            :total="total"
            :current-page.sync="pageConfig.current"
            @change="handlePageChange"
          />
        </div>
      </div>
    </basic-container>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { merge } from '@/util/common';
import { downloadFile } from '@/util/util';
import ListMixins from '@/util/mixins/listPage';
  export default {
    name: 'WithdrawLogsPage',
    mixins: [ListMixins],
    data() {
      return {
        listLoading: false,
        form: {
          keyword: '',
          incomeStatus: '',
          createDateBegin: '',
          createDateEnd: ''
        }
      }
    },
    computed: {
      ...mapState('partner', ['withdrawList', 'total']),
      ...mapGetters('app', ['viewportSize']),
      ...mapGetters('partner', ['withdrawStatusOptions', 'withdrawTypes'])
    },
    methods: {
      ...mapActions('partner', ['getWithdrawLogs', 'getDicts']),
      getList() {
        const query = merge({}, this.form, this.pageConfig);
        this.listLoading = true;
        this.getWithdrawLogs(query).finally(() => {
          this.listLoading = false;
        });
      },
      // 格式状态
      formatStatus({ status }) {
        for(let item of this.withdrawStatusOptions) {
          if (item.dictKey == status) {
            return item.dictValue
          }
        }
      },
      // 提现方式
      formatType({ withdrawalType }) {
        for(let item of this.withdrawTypes) {
          if (item.dictKey == withdrawalType) {
            return item.dictValue
          }
        }
      },
      // 导出数据
      handleExport () {
        const query = merge({}, this.form);
        downloadFile('/lebo-user/userwithdrawal/export-record', query);
      }
    },
    created() {
      this.form.keyword = this.$route.query.id;
      this.form.incomeStatus = this.$route.query.status;
      this.getDicts('WITHDRAW_STATUS');
      this.getDicts('WITHDRAW_TYPES');
      this.getList();
    }
  }
</script>
<style lang="scss">
  .table-pagination {
    margin-top: 20px;
    text-align: right;
  }
</style>
